import React,{useState, useEffect, useContext} from "react";
import { Col, Row, Form, Modal, Card, Button, Spinner,Dropdown, Badge} from "react-bootstrap";
import { X,  PencilSimple, DotsThreeVertical,UserCircleDashed,Copy,DownloadSimple, Swap, Trash,BookOpen, Check, CaretUp, CaretDown, Plus} from "@phosphor-icons/react";
import {formatDate, timeAgo, sortByDate2, norm} from  "../utils/functions";
import DataTableFilter from "../components/DataTableFilter";
import DialogUploadLayer from "../layouts/DialogUploadLayer";
import DialogScenarioManage from "../layouts/DialogScenarioManage";
import ScenarioTag				from "../components/ScenarioTag";
import globalContext		from "../utils/globalContext";

export default function ScenarioSwitch({
	scenario,
	project,
	scenarios,
	selectedScenario,
	onSelectScenario,
	onDelete,
	onClose,
	onSave,
	onDownload,
	onVersions,
	onViewNotes,
	versionid,
	onRequestLandOwners,
	onSetMain,
	onTerminate,
	onDuplicate,
	onReplace,
	onReplaceRoads,
	onReplacePowerlines,
	onReplaceTurbines,
	hasChanges,
	user,
	active,
}) {
	const allScenarios						= sortByDate2(project.scenarios, "updated", "desc");

	const [data,setData]					= useState(allScenarios);

	useEffect(()=>{
		setData(sortByDate2(project.scenarios, "updated", "desc"));
	}, [project.scenarios]);
	const [showQuickList,setShowQuickList]	= useState(false);
	const [needle,setNeedle]				= useState('');
	const [manageScenarios,setManageScenarios]				= useState({open:false});
	const [uploadLayer,setUploadLayer]		= useState({open:false, onUpload:{}});

	const context = useContext(globalContext);
	
	//const [needle,setNeedle]				= useState("");
	var n = "";

	
	const handleChangeScenario = (e) => {
		onSelectScenario(e);
		//this.forceUpdate();

	}
	const handleDeleteScenario = (e) => {
		onDelete(e);

	}
	const handleDuplicateScenario = (e) => {
		onDuplicate(e);

	}
	const handleRequestLandowners = (e) => {
		onRequestLandOwners(e);

	}
	const handleSaveScenario = (e, rename) => {
		onSave(e, rename);

	}
	const handleDownload = (e) => {
		onDownload(e);

	}
	const handleSetMain = (e) => {
		onSetMain(e);

	}
	const handleTerminate = (e) => {
		onTerminate(e);

	}
	const handleViewVersions = (e) => {
		onVersions(e);

	}
	const handleNotes = (e) => {
		onViewNotes(e);

	}
	const handleClose = (e) => {
		
		if(hasChanges) {
			e.preventDefault();
			onClose(()=>{window.location.href=e.target.parentNode.href});
		}

	}
	const handleBoundaryUpload = (layer) => {
		if(onReplace)
			onReplace(layer);

	}
	const handleBoundaryUploadRoads = (layer) => {
		if(onReplaceRoads)
			onReplaceRoads(layer);

	}
	const handleBoundaryUploadPowerlines = (layer) => {
		if(onReplacePowerlines)
			onReplacePowerlines(layer);

	}
	const handleBoundaryUploadTurbines = (layer) => {
		if(onReplaceTurbines)
			onReplaceTurbines(layer);

	}
	
	const handleNeedle = (text) => {
		
		n = text;
		
		const filtered = allScenarios.filter(searchNeedle);
		
		setData(filtered);
		setNeedle(text);
	}
	const handleCloseList = (e)=>{
		
		setShowQuickList(false);
		document.removeEventListener("click", handleCloseList);
	}
	const handleToggleQuickList = (e)=>{
		e.stopPropagation();
		if(!showQuickList){
			setShowQuickList(true);
			document.addEventListener("click", handleCloseList);
		}
		else{
			handleCloseList(e);
		}
	}
	
	const handleCreate = () => {
		context.dialogs.setCopyScenario({open:true, user:context.getters.user, selected:main, projectid:main.projectid, options:context.getters.scenarios, name:needle});
	}
	
	const handleSelect = () => {
		
	}
	const handleSeeAll = () =>{
		
		setManageScenarios({open:true, projectid:project.projectid});
		handleCloseList();
	}
	const handleCloseManager = (data) => {
		setManageScenarios({open:false});
		
		setData(sortByDate2(data, "updated", "desc"))
	}
	const searchNeedle = (item) => {
		
		if(n.length < 3)
			return true;
		
		/* we use search now, therefor the >-1 condition, eventualy we can use regexp for boolean and search ranking*/
		return 	(
			item.name && norm(item.name).match(new RegExp(norm(n), "i"))
			||
			item.created_by && item.created_by.email && norm(item.created_by.email).match(new RegExp(norm(n), "i"))
			||
			item.created_by && item.created_by.name && norm(item.created_by.name).match(new RegExp(norm(n), "i"))
		)
	}
	
	const current = allScenarios.find((s)=>{return s.scenarioid == scenario.scenario_id});
	const main = allScenarios.find((s)=>{return !s.scenarioid});
	
	return (
		<>
			<div className="nav-group project-panel pb-0 show">
				<div className="scenario">
				
					<Button variant="primary" className="w-100" onClick={handleToggleQuickList}><div>{current.name}</div>{ showQuickList ? <CaretUp  weight="bold" size={16} /> : <CaretDown  weight="bold" size={16} />}</Button>
					
					<Dropdown className="scenario-context">
						<Dropdown.Toggle variant="outline-primary"><DotsThreeVertical size={16} /></Dropdown.Toggle>
						<Dropdown.Menu>
							{/*<Dropdown.Item href="#" onClick={(e)=>{this.handleRequestLandowners(e);}} className="important"><UserCircleDashed size={14} /> Request Land Owners</Dropdown.Item>*/}
							<Dropdown.Item href="#" onClick={(e)=>{handleDuplicateScenario(e);}} className="details"><Copy size={14} /> Duplicate</Dropdown.Item>
							<Dropdown.Item href="#" onClick={(e)=>{handleSetMain(e);}} disabled={!scenario || !scenario.scenario_id || !user.userDetails || versionid || hasChanges}  className="details"><PencilSimple size={14} /> Set as Main</Dropdown.Item> 
							<Dropdown.Item href="#" onClick={(e)=>{handleSaveScenario(e, true);}} disabled={!scenario || !scenario.scenario_id } className="important"><PencilSimple size={14} /> Edit scenario</Dropdown.Item>
							<Dropdown.Item href="#" onClick={(e)=>{handleDownload(e);}} disabled={!scenario} className="important"><DownloadSimple size={14} /> Download</Dropdown.Item>
							<Dropdown.Item href="#" onClick={(e)=>{setUploadLayer({open:true, title:'Upload boundary', onUpload:handleBoundaryUpload})}} disabled={!scenario || !scenario.scenario_id} className="important"><Swap size={14} /> Replace boundary</Dropdown.Item>
							<Dropdown.Item href="#" onClick={(e)=>{setUploadLayer({open:true, title:'Upload roads', onUpload:handleBoundaryUploadRoads})}} disabled={!scenario || !scenario.scenario_id} className="important"><Swap size={14} /> Replace roads</Dropdown.Item>
							<Dropdown.Item href="#" onClick={(e)=>{setUploadLayer({open:true, title:'Upload powerlines', onUpload:handleBoundaryUploadPowerlines})}} disabled={!scenario || !scenario.scenario_id} className="important"><Swap size={14} /> Replace powerlines</Dropdown.Item>
							<Dropdown.Item href="#" onClick={(e)=>{setUploadLayer({open:true, title:'Upload turbines', onUpload:handleBoundaryUploadTurbines})}} disabled={!scenario || !scenario.scenario_id} className="important"><Swap size={14} /> Replace turbines</Dropdown.Item>
							<Dropdown.Item href="#" onClick={(e)=>{handleDeleteScenario(e);}} disabled={!scenario || !scenario.scenario_id || versionid} className="share text-danger"><Trash size={14} /> Delete</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
					
				</div>
			</div>
			{ showQuickList && 
			<div className=" scenario-switch-wrp" onClick={(e)=>{e.stopPropagation();}}>
				<div className=" card scenario-switch" >
					<Row>
						<Col xs="12 title">
							Switch scenario
							<span onClick={handleCloseList} className="btn btn-close btn-sm float-end"><X weight="bold" size={12} /></span>
						</Col>
					</Row>
					<Row className="row-search">
						<Col xs="12">
							<DataTableFilter value={needle} onChange={handleNeedle} />
						</Col>
					</Row>
					<Row>
						<Col xs="12 scenario-list">
							<table>
								{needle.length < 3 &&
								<tr key={0} onClick={()=>{handleChangeScenario({value:0, label:main.name}); handleCloseList();}} className={!current.scenarioid ? 'active' : ''}>
									<td className="icon">
									{!current.scenarioid && 
										<Check weight="bold" size={16} />
									}
									</td>
									<td className="name">
										{main.name}
									</td>
									<td className="tags">
										<ScenarioTag scenario={main} />
									</td>
									<td className="created">
										{main.created_by.name}
									</td>
									<td className="date">
										{timeAgo(main.updated)}
									</td>
								</tr>
								}
								{data.filter((a)=>{return !!a.scenarioid}).slice(0,5).map((s, j)=>{

									return (
										<tr key={j} className={(s.scenarioid == current.scenarioid ? 'active' : '')} onClick={()=>{handleChangeScenario({value:s.scenarioid, label:s.name}); handleCloseList();}}>

											<td className="icon">
												{s.scenarioid == current.scenarioid &&
												<Check weight="bold" size={16} />
												}
											</td>
											<td className="name">
												{s.name}
											</td>
											<td className="tags">
												<ScenarioTag scenario={s} />
											</td>
											<td className="created">
												{s.created_by.name}
											</td>
											<td className="date">
												{timeAgo(s.updated)}
											</td>
										</tr>
									)
								})}
							</table>
							{!data.length &&
								<Row className="create" onClick={handleCreate}>

									<Col xs="12">
										<Plus weight="bold" size={16} className="me-2" /> Create scenario <b>{needle}</b> from <b>Main</b>
									</Col>
								</Row>
							}

						</Col>
					</Row>

					<Row>
						<Col xs="12 seeall" onClick={handleSeeAll}>
							See all scenarios
						</Col>
					</Row>


				</div>	
			</div>
			}
			<DialogScenarioManage setup={manageScenarios} scenarios={project.scenarios} onChangeScenario={handleChangeScenario} onClose={handleCloseManager} />
			<DialogUploadLayer setup={uploadLayer} title={uploadLayer.title} type="convertLayer" onClose={()=>{setUploadLayer({open:false, onUpload:handleBoundaryUpload})}} />	  
		</>  
	);
	

}